const DEFAULT_FONT_SIZE = 16

export const remToPx = (rem: number) => rem * DEFAULT_FONT_SIZE
